// Public surface of the VAT engine. CommonJS: the server requires this file
// (`require('../../src/util/vat')`), the client imports it by name.
//
// Object.assign rather than an object literal with spreads: webpack 4 reads
// a `module.exports = { ... }` literal as the static export list and does not
// see the spread members, which fails the client build with "Attempted import
// error: 'EU_VAT_AREA' is not exported". A call expression keeps the exports
// dynamic, so named imports resolve at runtime.
module.exports = Object.assign(
  {},
  require('./regions'),
  require('./rates'),
  require('./notes'),
  require('./resolve'),
  require('./transaction'),
  require('./lineItems'),
  require('./snapshot'),
  require('./parties'),
  require('./display')
);
